import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const notificationChannelService = { getAll, updateStatus };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) params.search_words = searchWords;
    return apiHelper(API_URL).get('/notification-channels', { params });
}

export function updateStatus(uuid, isActive) {
    return apiHelper(API_URL).patch(`/notification-channels/${uuid}`, {
        is_active: isActive ? 1 : 0,
    });
}
